import loadLocaleBundle from 'Translations/loadLocaleBundle'

// Start fetching the active locale's translations at script-eval time so the
// bundle is registered before components hydrate (no English flash on non-EN
// pages). Resolves immediately on English pages.
const localeReady = loadLocaleBundle()

var init = () => {
  localeReady.then(() => {
    const ReactRailsUJS = require('react_ujs')
    const context = require.context('Pods', true, /\/ListingPage\/(?!.*(?:test|story).*$).*$/)

    ReactRailsUJS.useContext(context)
    ReactRailsUJS.mountComponents("#listing-page-elements")
  })
}

document.readyState === 'complete' ? init() : window.addEventListener('load', init)
